import type { ScenarioEngine } from '../scenario/engine';
import { createToolDefinitions } from './tools';

export async function registerWebMcpTools(engine: ScenarioEngine): Promise<AbortController | null> {
  if (!document.modelContext || typeof document.modelContext.registerTool !== 'function') {
    engine.setWebMcpStatus('unavailable', 'WebMCP is unavailable in this browser. Manual demo mode is active.');
    return null;
  }

  const controller = new AbortController();
  try {
    await Promise.all(
      createToolDefinitions(engine).map((tool) => document.modelContext!.registerTool(tool, { signal: controller.signal })),
    );
    engine.setWebMcpStatus('registered', '7 tools registered with document.modelContext');
    return controller;
  } catch (error) {
    controller.abort();
    const detail = error instanceof Error ? error.message : 'Unknown registration failure';
    engine.setWebMcpStatus('error', `WebMCP registration failed: ${detail}. Manual demo mode is active.`);
    return null;
  }
}
